<template>
  <div class="edit_main">
    <Form class="fx_1" ref="detailModel" :model="detailModel" :label-width="100" inline>
      <FormItem label="用户名" prop="userName">
        <Input disabled class="w-250" v-model="detailModel.userName"></Input>
      </FormItem>
      <FormItem label="用户编号" prop="userCode">
        <Input disabled class="w-250" v-model="detailModel.userCode"></Input>
      </FormItem>

      <FormItem label="用户类型">
        <Select disabled class="w-250" v-model="detailModel.userType">
          <Option
            v-for="(item, index) in userTypeSelect"
            :value="item.dictionaryID"
            :key="index"
            >{{ item.dictionaryValue }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="英文名">
        <Input disabled class="w-250" v-model="detailModel.userNameEN"></Input>
      </FormItem>
      <FormItem label="性别">
        <Select disabled class="w-250" v-model="detailModel.userSex" clearable>
          <Option value="0">男</Option>
          <Option value="1">女</Option>
        </Select>
      </FormItem>
      <FormItem label="身份证号">
        <Input disabled class="w-250" v-model="detailModel.idCardNO"></Input>
      </FormItem>
      <FormItem label="出生日期">
        <DatePicker
          disabled
          v-model="detailModel.userBirth"
          type="date"
          class="w-250"
        ></DatePicker>
      </FormItem>
      <FormItem label="入职日期">
        <DatePicker
          disabled
          v-model="detailModel.entryDate"
          type="date"
          class="w-250"
        ></DatePicker>
      </FormItem>
      <FormItem label="离职日期">
        <DatePicker
          disabled
          v-model="detailModel.quitDate"
          type="date"
          class="w-250"
        ></DatePicker>
      </FormItem>

      <FormItem label="手机号">
        <Input disabled class="w-250" v-model="detailModel.userMobile"></Input>
      </FormItem>
      <FormItem label="座机号">
        <Input disabled class="w-250" v-model="detailModel.userTell"></Input>
      </FormItem>
      <FormItem label="邮箱">
        <Input disabled class="w-250" v-model="detailModel.userEmail"></Input>
      </FormItem>
      <FormItem label="住址">
        <Input disabled class="w-250" v-model="detailModel.userAddress"></Input>
      </FormItem>

      <FormItem label="科室">
        <span class="ml-5">{{ detailModel.departmentname }}</span>
      </FormItem>

      <FormItem label="备注" class="show">
        <Input
          disabled
          class="w-250"
          v-model="detailModel.userRemark"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 8 }"
        ></Input>
      </FormItem>
      <FormItem label="签名" class="show">
        <img
          v-bind:src="signimageUrl"
          style="max-width: 500px; max-height: 500px"
        />
      </FormItem>
    </Form>

    <div class="edit_btn_group">
      <Button type="primary" @click="returnBack">返 回</Button>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      userTypeSelect: [],
      treeModel: false,
      organParentName: "",
      signimageUrl: "",
      detailModel: {},
    };
  },

  mounted: function () {
    this.$common.getDictionary("用户类型").then((data) => {
      this.userTypeSelect = data;
    });
    this.initData(this.$route.query.id);
  },

  methods: {
    initData(id) {
      this.$api.get(`user/getById?id=${id}`).then((rsp) => {
        if (rsp != false) {
          this.detailModel = rsp.data;
          this.signimageUrl =
            localStorage.getItem("baseURL") + this.detailModel.signImage;
        }
      });
    },
    returnBack: function () {
      this.$router.push("user");
    },
  },
};
</script>
<style scoped>
</style>